export function getThemeStorageKey(userId: string | undefined) {
  return `flashcards-theme:${userId ?? 'anonymous'}`
}
